export const GoogleAPIkey = "AIzaSyBJEmVrMq5Zgj27dilri-OK76pn7pgQCho";
export const locationSite1 = {
  lat: 12.6999465,
  lng: 101.1347889,
};
//"AIzaSyBJEmVrMq5Zgj27dilri-OK76pn7pgQCho"
